import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Transaction {
  id: string;
  type: 'income' | 'expense';
  amount: number;
  [key: string]: unknown;
}

interface FinanceState {
  transactions: Transaction[];
  balance: number;
  isLoading: boolean;
  error: string | null;
}

const initialState: FinanceState = {
  transactions: [],
  balance: 0,
  isLoading: false,
  error: null,
};

const financeSlice = createSlice({
  name: 'finance',
  initialState,
  reducers: {
    addTransaction: (state, action: PayloadAction<Transaction>) => {
      const transaction = action.payload;
      state.transactions.push(transaction);

      if (transaction.type === 'income') {
        state.balance += transaction.amount;
      } else {
        state.balance -= transaction.amount;
      }
    },
    deleteTransaction: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      const transactionIndex = state.transactions.findIndex(t => t.id === id);

      if (transactionIndex !== -1) {
        const transaction = state.transactions[transactionIndex];

        if (transaction.type === 'income') {
          state.balance -= transaction.amount;
        } else {
          state.balance += transaction.amount;
        }

        state.transactions.splice(transactionIndex, 1);
      }
    },
    clearTransactions: (state) => {
      state.transactions = [];
      state.balance = 0;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  addTransaction,
  deleteTransaction,
  clearTransactions,
  setLoading,
  setError
} = financeSlice.actions;

export default financeSlice.reducer;
